import React from 'react'
import Dashboard from '../Dashboard';
import PlanATripProcessMain from './PlanATripProcessMain'

export default function PlanATripProcess() {
    return (
        <div>
            <Dashboard cmp={<PlanATripProcessMain />} />
        </div>
    )
}
